<div class="minimizedCall p-1 px-3 border-bottom" *ngIf="minimizeCall" (click)="maximizeCall()">
  <div class="d-flex align-items-start justify-content-between">
    <div>{{(peerUserInCallName)}}</div>
    <div class="d-flex">
      <i class="ri-phone-fill pe-1"></i>
      {{formatTimer(currentCall?.duration)}}
    </div>
  </div>
</div>
